import Link from 'next/link';
import { useCallback, useMemo } from 'react';
import classes from './columnItem.module.css';
const SizeItem = props => {
  const { filterApi, filterState, group, item, onApply, onFilterItemMouseDown, handleGenerateLinkHref } = props;

  const { removeItem, addItem } = filterApi;
  const { title, value, count, swatch_data } = item;

  const { value: swatch_data_value } = swatch_data || {};

  const isSelected = filterState && Array.from(filterState).some(filterItem => filterItem.value === item.value);
  console.log('columnItem', props);
  // create and memoize an item that matches the tile interface
  const tileItem = useMemo(
    () => ({
      label: title,
      value_index: value,
    }),
    [title, value],
  );

  const handleClick = useCallback(
    e => {
      onFilterItemMouseDown();
      console.log('columnItem', e.button, group);

      // use only left click for selection
      if (e.button !== 0) {
        return;
      }

      // removeItem({
      //   group
      // });

      if (isSelected) {
        removeItem({
          group,
          item,
        });
      } else {
        addItem({
          group,
          item,
        });
      }

      if (typeof onApply === 'function') {
        onApply(group, item);
      }
    },
    [group, item, removeItem, addItem, onApply, isSelected],
  );

  const handleKeyDown = useCallback(
    e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();

        // removeItem({
        //   group
        // });

        if (isSelected) {
          removeItem({
            group,
            item,
          });
        } else {
          addItem({
            group,
            item,
          });
        }

        if (typeof onApply === 'function') {
          onApply(group, item);
        }
      }
    },
    [group, item, onApply, removeItem, addItem, isSelected],
  );
  const nextPath =
    handleGenerateLinkHref &&
    handleGenerateLinkHref({
      group,
      item,
    });

  return (
    <span
      className={`${classes.root} ${isSelected ? classes.rootActive : ''}`}
      onMouseDown={handleClick}
      onKeyDown={handleKeyDown}
    >
      <Link
        href={nextPath}
        className={classes.title}
        onClick={e => {
          e.preventDefault();
        }}
      >
        {title}
      </Link>
    </span>
  );
};

export default SizeItem;
